import { Component, Input, OnDestroy, OnInit, ViewChildren} from '@angular/core';
import {AbstractColorPicker} from 'src/app/components_2.1/color-picker/abstract-color-picker';
import {WhiteTooltipDirective} from '../../../directives/whiteTooltip/white-tooltip.directive';

@Component({
  selector: 'app-color-picker-native',
  templateUrl: './color-picker-native.component.html',
  styleUrls: ['./color-picker-native.component.scss']
})
export class ColorPickerNativeComponent extends AbstractColorPicker implements OnInit, OnDestroy {

  @ViewChildren(WhiteTooltipDirective) tooltips;
  @Input() item;

  constructor() {
    super();
  }

  get isDefaultValue(): boolean {
    if (this.item && this.selectedColor) {
      return this.selectedColor == this.getDefaultColor();
    }
    return true;
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.tooltips.forEach((item) => {
      item.hide();
    });
  }

  resetToDefault() {
    if (!this.isDefaultValue) {
      this.selectedColor = this.getDefaultColor();
      this.change();
    }
  }

  getDefaultColor() {
    if (this.item) {
      let val = this.item.config.getTool().default_color;
      if (val.trim().charAt(0) !== '#') {
        val = this.tryGetColorHexFromString(val);
      }
      return val;
    }
    return '#ffffff';
  }
}
